// extracted by mini-css-extract-plugin
export default {"seperator":"CardPanel__seperator___xSqGp","cardPanel":"CardPanel__cardPanel___tLzfk","cardPanelHeading":"CardPanel__cardPanelHeading___Kq7rL"};